import { FinishComponentView } from '../FinishComponentView';
import { WprBaseViewModeInfo } from '../../../wpr-framework/mode/WprBaseViewMode';

/**
 * 契約完了画面保険項目(OTA/DTP)切替モード
 */
export class FinishItemMode extends WprBaseViewModeInfo<FinishComponentView>{
	// コンストラクタ  -----------------------------------------------------------
	public constructor() {
		super('finishItemMode');
	}
	// --------------------------------------------------------------------------
	// override メソッド  --------------------------------------------------------
	/**
	 * モードリスト取得（この画面モードで使用する全てのモードを定義する）
	 * @param list モードリスト
	 */
	public useModeList(list: string[]): void {
		list.push('OTA');
		list.push('DTP');
	}

	/**
	 * フィールド定義を登録
	 */
	public onRegisterControl(): void {
		this.addControl('insuranceType', { value: [{ mode: 'OTA', value: '海外旅行傷害保険' }, { mode: 'DTP', value: '国内旅行傷害保険' },], });
	}

	/**
	 * 画面の状態をチェックしてモードを変更する
	 * @param curMode 現在のモード
	 * @return 新しいモード（変更ない場合は現在のモード）
	 */
	public onCheckMode(curMode: string): string {
		return this.getGlobalMode('product');
	}
	// --------------------------------------------------------------------------
}